import React from 'react';
import { Grid, Paper } from '@mui/material';
import PublicHeader from 'components/PublicHeader';
import ConfirmRegistrationWrapper from 'components/ConfirmRegistration';
import FooterWrapper from 'components/Footer';
import { styled } from '@mui/material/styles';
import { getPaperStyleObject } from 'styles/Paper';

const StyledPaper = styled(Paper)((
    {
        theme
    }
    ) => {
        let paperStyle = getPaperStyleObject(theme);
        return {
            ...paperStyle.root
        };
    });

const ConfirmRegistration = () => {

    document.title = "3M VAS - Confirm Registration";

    return (
        <section>
            <PublicHeader />
            <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={12}>
                    <Grid container alignItems="center" justifyContent="center" direction="column">
                        <Grid item>
                            <StyledPaper>
                                <ConfirmRegistrationWrapper search={window.location.search} />
                            </StyledPaper>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <FooterWrapper />
        </section>
    );
};

export default ConfirmRegistration;